module.exports = __webpack_public_path__ + "static/media/7-audio.32e2cb6.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/7-audio.wav
// module id = IyrN
// module chunks = 0